__turbopack_context__.v({
  "className": "montserrat_1d6aac72-module__chcTNG__className",
});
